import { useEffect, useState } from 'react';

type AnimatedUnderlineProps = {
  children: React.ReactNode;
  delayMs?: number;
};

export function AnimatedUnderline({ children, delayMs = 0 }: AnimatedUnderlineProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const mediaQuery =
      typeof window !== 'undefined'
        ? window.matchMedia('(prefers-reduced-motion: reduce)')
        : { matches: false };

    if (mediaQuery.matches) {
      setIsVisible(true);
    } else {
      const timeout = setTimeout(() => setIsVisible(true), delayMs);
      return () => clearTimeout(timeout);
    }
  }, [delayMs]);

  return (
    <span className="relative inline-block text-green-lime italic">
      <span
        className={`${isVisible ? 'w-full' : 'w-0'} absolute bottom-1 left-1 h-3 bg-green-lime z-0 transition-[width] duration-300 ease-out`}
      />
      <span className="relative z-10 font-medium">{children}</span>
    </span>
  );
}
